import { render, staticRenderFns } from "./reChargePrivacy.vue?vue&type=template&id=053c5655&scoped=true"
import script from "./reChargePrivacy.vue?vue&type=script&lang=js"
export * from "./reChargePrivacy.vue?vue&type=script&lang=js"
import style0 from "./reChargePrivacy.vue?vue&type=style&index=0&id=053c5655&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c5655",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053c5655')) {
      api.createRecord('053c5655', component.options)
    } else {
      api.reload('053c5655', component.options)
    }
    module.hot.accept("./reChargePrivacy.vue?vue&type=template&id=053c5655&scoped=true", function () {
      api.rerender('053c5655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/ozonPrint/components/reChargePrivacy.vue"
export default component.exports